
  (function() {
    function moveWidget(targetId, widgetSelector) {
      var target = document.getElementById(targetId);
      var widget = document.querySelector(widgetSelector);
      if (target && widget) {
        var parent = widget.closest('.shopify-block');
        if (parent) {
          target.appendChild(parent);
          parent.style.display = 'block';
        } else {
          target.appendChild(widget);
        }
        target.style.visibility = 'visible';
        return true;
      }
      return false;
    }

    // Hide targets until ready
    ['scalpay-msg-showhere', 'yotpo-stars-showhere'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.visibility = 'hidden';
    });

    var widgets = [
      { target: 'scalpay-msg-showhere', selector: 'scalapay-widget' },
      { target: 'pdp-fbq-show-here', selector: '.cbb-frequently-bought-container ' },
      { target: 'yotpo-stars-showhere', selector: '[data-yotpo-instance-id]' },
      { target: 'yotpo-stars-showhere', selector: '.jdgm-preview-badge' }
    ];

    var remaining = widgets.filter(function(w) { return !moveWidget(w.target, w.selector); });

    if (remaining.length) {
      var observer = new MutationObserver(function() {
        remaining = remaining.filter(function(w) { return !moveWidget(w.target, w.selector); });
        if (!remaining.length) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() { observer.disconnect(); }, 10000);
    }
  })();

  

  

  document.addEventListener('DOMContentLoaded', function () {
    var appHolder = document.getElementById('pdp-fbq-show-here');
    var mobileAnchor = document.getElementById('pdp-fbq-mobile-anchor');

    if (!appHolder || !mobileAnchor) return;

    function placeFbqAppMobileOnly() {
      if (window.innerWidth <= 749) {
        if (appHolder.parentNode !== mobileAnchor) {
          mobileAnchor.appendChild(appHolder);
        }
      }
    }

    function placeFbqAppDesktopBack() {
      if (window.innerWidth > 749) {
        var mediaGallery = document.getElementById('MediaGallery-{{ section.id }}');
        if (mediaGallery && appHolder.parentNode !== mediaGallery) {
          mediaGallery.appendChild(appHolder);
        }
      }
    }

    function handleFbqPlacement() {
      if (window.innerWidth <= 749) {
        placeFbqAppMobileOnly();
      } else {
        placeFbqAppDesktopBack();
      }
    }

    setTimeout(handleFbqPlacement, 800);
    setTimeout(handleFbqPlacement, 1600);
    setTimeout(handleFbqPlacement, 2500);

    window.addEventListener('resize', handleFbqPlacement);

    var observer = new MutationObserver(function () {
      handleFbqPlacement();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
